// DS: DS2.6
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import ConditionalWrapper from '../ConditionalWrapper';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './ToggleButton.scss';
const ToggleButton = (_param)=>{
    var { tooltipText, activated, disabled, icon: Icon, iconRef, label, className } = _param, rest = _object_without_properties(_param, [
        "tooltipText",
        "activated",
        "disabled",
        "icon",
        "iconRef",
        "label",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: tooltipText !== undefined,
        wrap: (child)=>/*#__PURE__*/ React.createElement(SimpleTooltip, {
                text: tooltipText,
                placement: "top"
            }, child)
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: c(s['root'], activated && s['on'], disabled && s['disabled'], className),
        disabled: disabled
    }, rest), /*#__PURE__*/ React.createElement(Icon, {
        className: s['icon'],
        size: IconSize.MEDIUM,
        disableDefaultColors: true,
        containerRef: iconRef
    }), label && /*#__PURE__*/ React.createElement("span", {
        className: s['label']
    }, label)));
};
ToggleButton.displayName = 'ToggleButton';
export default ToggleButton;
